module.exports = __webpack_public_path__ + "media/images/empresa/medios-aad25c7538ff6f67cf0362f67dc35102.png";